// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,

  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
    report: path(ROOTS_DASHBOARD, "/report"),
  },

  desigination: {
    root: path(ROOTS_DASHBOARD, "/desigination"),
    new: path(ROOTS_DASHBOARD, "/desigination/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/desigination/${id}/edit`),
  },
  user: {
    root: path(ROOTS_DASHBOARD, "/user"),
    new: path(ROOTS_DASHBOARD, "/user/new"),
    list: path(ROOTS_DASHBOARD, "/user/list"),
    cards: path(ROOTS_DASHBOARD, "/user/cards"),
    profile: path(ROOTS_DASHBOARD, "/user/profile"),
    account: path(ROOTS_DASHBOARD, "/user/account"),
    edit: (id) => path(ROOTS_DASHBOARD, `/user/${id}/edit`),
    replicate: (id) => path(ROOTS_DASHBOARD, `/user/${id}/replicate`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },

  supplier: {
    root: path(ROOTS_DASHBOARD, "/supplier"),
    new: path(ROOTS_DASHBOARD, "/supplier/new"),
    list: path(ROOTS_DASHBOARD, "/supplier/list"),
    edit: (id) => path(ROOTS_DASHBOARD, `/supplier/${id}/edit`),
    replicate: (id) => path(ROOTS_DASHBOARD, `/supplier/${id}/replicate`),
  },

  stock: {
    display: path(ROOTS_DASHBOARD, "/stock/display"),
    live: path(ROOTS_DASHBOARD, "/stock/live"),
    new: path(ROOTS_DASHBOARD, "/stock/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/stock/${id}/edit`),
    adjustment: path(ROOTS_DASHBOARD, "/stock/adjustment"),
    addAdjustment: path(ROOTS_DASHBOARD, "/stock/adjustment/new"),
    adjustmentEdit: (id) =>
      path(ROOTS_DASHBOARD, `/stock/adjustment/${id}/edit`),
    purchaseOrders: path(ROOTS_DASHBOARD, "/stock/purchaseOrders"),
    addPurchaseOrders: path(ROOTS_DASHBOARD, "/stock/purchaseOrders/new"),
    purchaseOrderEdit: (id) =>
      path(ROOTS_DASHBOARD, `/stock/purchaseOrders/${id}/edit`),
    stockTransfer: path(ROOTS_DASHBOARD, "/stock/stockTransfer"),
    addStockTransfer: path(ROOTS_DASHBOARD, "/stock/stockTransfer/new"),
    stockTransferEdit: (id) => path(ROOTS_DASHBOARD, `/stock/stockTransfer/${id}/edit`),
  },

  item: {
    list: path(ROOTS_DASHBOARD, "/item/list"),
    new: path(ROOTS_DASHBOARD, "/item/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/item/${id}/edit`),
  },

  invoice: {
    list: path(ROOTS_DASHBOARD, "/invoice/list"),

  },

  settings: {
    list: path(ROOTS_DASHBOARD, "/settings/list"),
    new: path(ROOTS_DASHBOARD, "/settings/new"),
    account: path(ROOTS_DASHBOARD, "/settings/account"),
    kds: path(ROOTS_DASHBOARD, "/settings/kds"),
    edit: (id) => path(ROOTS_DASHBOARD, `/settings/${id}/edit`),
  },
};

export const PATH_DOCS = {
  root: "https://docs.minimals.cc",
  changelog: "https://docs.minimals.cc/changelog",
};

export const PATH_ZONE_ON_STORE =
  "https://mui.com/store/items/zone-landing-page/";

export const PATH_MINIMAL_ON_STORE =
  "https://mui.com/store/items/minimal-dashboard/";

export const PATH_FREE_VERSION =
  "https://mui.com/store/items/minimal-dashboard-free/";

export const PATH_FIGMA_PREVIEW =
  "https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1";
